import { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Modal.module.css";

/**
 * Standard modal component following project design patterns.
 * Uses green-lightest background and standard fade-in animation.
 * Blocks body scroll when mounted.
 *
 * @example
 * <Modal isOpen={showModal} onClose={handleClose} title="Create User">
 *   <form>
 *     // Modal content
 *   </form>
 * </Modal>
 */
const Modal = ({ isOpen, onClose, title, children, className = "" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const boxClassName = `${styles.box} ${className}`.trim();

  return (
    <article className={styles.container}>
      <div
        className={styles.background}
        aria-hidden="true"
        onClick={handleBackgroundClick}
      />
      <section className={boxClassName}>
        {title && <h2 className={styles.header}>{title}</h2>}
        {children}
      </section>
    </article>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Modal;
